import { TypeInitProps, TypeRequest } from '../../../types';
import { encryptParams } from '../../../utils/index';
import { WEB_AFF_URL } from '../../../utils/urls';
export default class RegisterAPI {
  private request: any;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }
  /**
   * @param {string} email - the email used to register
   * @return {Promise} send result
   */
  sendEmailCode = (params: { email: string; extra_params?: object }) => {
    const { email, extra_params = {} } = params;
    const data = encryptParams({ email, type: 1, ...extra_params }, [
      'email',
      'type',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.SEND_EMAIL_CODE,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} email - the email to be verified
   * @param {string} code - the email captcha
   * @return {Promise} verify result
   */
  verifyEmail = (params: {
    email: string;
    code: string;
    extra_params?: object;
  }) => {
    const { email, code, extra_params = {} } = params;
    const data = encryptParams({ email, code, type: 1, ...extra_params }, [
      'email',
      'code',
      'type',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.CHECK_EMAIL_CODE,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} ticket - the ticket gained from verification
   * @param {string} base_infos
   * @param {string} subject_name
   * @param {string} password
   * @param {string} identity_card
   * @param {string} real_name
   * @param {string} only_user - whether register user account only
   * @return {Promise} register result
   */
  registerByEmail = (params: {
    ticket: string;
    base_infos: string;
    subject_name: string;
    password?: string;
    identity_card: string;
    real_name: string;
    only_user?: boolean;
    extra_params?: object;
  }) => {
    const { extra_params = {}, only_user = false, ...props } = params;
    const data = encryptParams({ ...props, ...extra_params }, [
      'base_infos',
      'subject_name',
      'password',
      'identity_card',
      'real_name',
    ]);
    const url = only_user
      ? WEB_AFF_URL.REGISTER_EMAIL_USER_ONLY
      : WEB_AFF_URL.REGISTER_EMAIL;
    return new Promise((resolve, reject) => {
      this.request({
        url,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} mobile - the mobile used to register
   * @return {Promise} send result
   */
  sendMobileCode = (params: { mobile: string; extra_params?: object }) => {
    const { mobile, extra_params = {} } = params;
    const data = encryptParams({ mobile, type: 1, ...extra_params }, [
      'mobile',
      'type',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.SEND_MOBILE_CODE,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} mobile - the mobile to be verified
   * @param {string} code - the mobile captcha
   * @return {Promise} verify result
   */
  verifyMobile = (params: {
    mobile: string;
    code: string;
    extra_params?: object;
  }) => {
    const { mobile, code, extra_params = {} } = params;
    const data = encryptParams({ mobile, code, type: 1, ...extra_params }, [
      'mobile',
      'code',
      'type',
    ]);
    return new Promise((resolve, reject) => {
      this.request({
        url: WEB_AFF_URL.CHECK_MOBILE_CODE,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };

  /**
   * @param {string} ticket - the ticket gained from verification
   * @param {string} base_infos
   * @param {string} subject_name
   * @param {string} password
   * @param {string} identity_card
   * @param {string} real_name
   * @param {string} only_user - whether register user account only
   * @return {Promise} register result
   */
  registerByMobile = (params: {
    ticket: string;
    base_infos: string;
    subject_name: string;
    password?: string;
    identity_card: string;
    real_name: string;
    only_user?: boolean;
    extra_params?: object;
  }) => {
    const { extra_params = {}, only_user = false, ...props } = params;
    const data = encryptParams({ ...props, ...extra_params }, [
      'base_infos',
      'subject_name',
      'password',
      'identity_card',
      'real_name',
    ]);
    const url = only_user
      ? WEB_AFF_URL.REGISTER_MOBILE_USER_ONLY
      : WEB_AFF_URL.REGISTER_MOBILE;
    return new Promise((resolve, reject) => {
      this.request({
        url,
        method: 'POST',
        data,
      })
        .then((data: any) => {
          resolve(data);
        })
        .catch((e: any) => {
          reject(e);
        });
    });
  };
}
